export default __webpack_public_path__ + "static/media/bg-character-img-2.365d77a8.png";